@if (productGroups.length > 0) {
  <div>
    <div class="page-header-row">
      <div class="intro-line-1" i18n="Introductory for product group list - line 1">
      Product group information
    </div>
      <button
        type="button"
        id="create-product-group-btn"
        class="btn btn-sm btn-primary"
        routerLink="/client/{{ client?.id }}/product-group/new"
        >
        <span class="button-text">Create New</span>
        <span class="icon icon-right">
          <i class="fa fa-plus-circle" aria-hidden="true"></i>
        </span>
      </button>
    </div>
    <div class="view-toggle" role="group" aria-label="Product group view">
      <button
        type="button"
        id="tile-view-btn"
        class="view-toggle-btn"
        [class.active]="viewMode === 'tile'"
        (click)="setViewMode('tile')"
        aria-label="Tile view"
        >
        <i class="fa fa-th-large" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        id="list-view-btn"
        class="view-toggle-btn"
        [class.active]="viewMode === 'list'"
        (click)="setViewMode('list')"
        aria-label="List view"
        >
        <i class="fa fa-list" aria-hidden="true"></i>
      </button>
    </div>
    <client-header
      [headerLabel]="'Product groups'"
      [headerGroup]="'productGroups'"
      (openHeader)="toggleHeader($event)"
      (closeHeader)="toggleHeader($event)"
    ></client-header>
    @if (headerGroups.productGroups) {
      @if (viewMode === 'tile') {
        <div class="create-panel">
          @for (product of productGroups; track product) {
            <div
              class="product"
        [ngStyle]="{
          'border-top-color': product.color,
          'border-bottom-color': product.color
        }"
              id="{{ assignID(product.name) }}-product-button"
              routerLink="/client/{{ client?.id }}/product-group/{{ product?.id }}"
              >
              <img [src]="product?.branding?.banner_s3_url" width="220" height="71" />
              <div
                class="product-title"
                [ngStyle]="{ color: product.color }"
                title="{{ product.name }}"
                >
                {{ product.name }}
              </div>
              <div class="product-subtitle" title="{{ product.internal_name }}">
                {{ product.internal_name }}
              </div>
              @if (isDefault(product)) {
                <div class="product-default" i18n="Label marking the default product group">
                  default
                </div>
              }
            </div>
          }
        </div>
      }
      @if (viewMode === 'list') {
        <div class="container-fluid product-group-table">
          <div class="row colhdrs">
            <div id="product-group-name-heading" class="colw colw-16 column-heading no-text-selection cursor-pointer" (click)="onColumnHeadingClick('name')">
              <span i18n="Product group name column heading">Product Group Name</span>
              <app-column-sort-icon id="sort-icon-product-group-name" [ordering]="ordering" [fieldName]="'name'"></app-column-sort-icon>
            </div>
            <div id="product-group-internal-name-heading" class="colw colw-16 column-heading no-text-selection cursor-pointer" (click)="onColumnHeadingClick('internal_name')">
              <span i18n="Product group internal name column heading">Product Group Internal Name</span>
              <app-column-sort-icon id="sort-icon-product-group-internal-name" [ordering]="ordering" [fieldName]="'internal_name'"></app-column-sort-icon>
            </div>
            <div id="product-group-id-heading" class="colw colw-16 column-heading no-text-selection cursor-pointer" (click)="onColumnHeadingClick('id')">
              <span i18n="Product ID column heading">Product ID</span>
              <app-column-sort-icon id="sort-icon-product-group-id" [ordering]="ordering" [fieldName]="'id'"></app-column-sort-icon>
            </div>
            <div id="product-group-vanity-url-heading" class="colw colw-16 column-heading no-text-selection cursor-pointer" (click)="onColumnHeadingClick('vanity_url')">
              <span i18n="Product group vanity URL column heading">Vanity URL</span>
              <app-column-sort-icon id="sort-icon-product-group-vanity-url" [ordering]="ordering" [fieldName]="'vanity_url'"></app-column-sort-icon>
            </div>
            <div id="product-group-created-at-heading" class="colw colw-16 column-heading no-text-selection cursor-pointer" (click)="onColumnHeadingClick('created_at')">
              <span i18n="Product group date created column heading">Date Created</span>
              <app-column-sort-icon id="sort-icon-product-group-created-at" [ordering]="ordering" [fieldName]="'created_at'"></app-column-sort-icon>
            </div>
            <div id="product-group-updated-at-heading" class="colw colw-16 column-heading no-text-selection cursor-pointer" (click)="onColumnHeadingClick('updated_at')">
              <span i18n="Product group date modified column heading">Date Modified</span>
              <app-column-sort-icon id="sort-icon-product-group-updated-at" [ordering]="ordering" [fieldName]="'updated_at'"></app-column-sort-icon>
            </div>
          </div>
          @for (product of listViewProductGroups; track product) {
            <div
              class="row product-group-row"
              id="{{ assignID(product.name) }}-product-row"
              routerLink="/client/{{ client?.id }}/product-group/{{ product?.id }}"
              >
              <div class="colw colw-16 product-group-cell" title="{{ product.name }}">
                {{ product.name }}
                @if (isDefault(product)) {
                  <span class="product-default-inline" i18n="Label marking the default product group">(default)</span>
                }
              </div>
              <div class="colw colw-16 product-group-cell" title="{{ product.internal_name }}">{{ product.internal_name }}</div>
              <div class="colw colw-16 product-group-cell" title="{{ product.id }}">{{ product.id }}</div>
              <div class="colw colw-16 product-group-cell" title="{{ product.vanity_url }}">{{ product.vanity_url }}</div>
              <div class="colw colw-16 product-group-cell">{{ product.created_at | date:'shortDate' }}</div>
              <div class="colw colw-16 product-group-cell">{{ product.updated_at | date:'shortDate' }}</div>
            </div>
          }
        </div>
      }
    }
  </div>
}

@if (productGroups.length === 0) {
  <div>
    <div class="page-header-row">
      <div
        class="intro-line-1"
        i18n="Introductory for creating a new product group - line 1"
        >
      Do. Or do not. There is no try.
    </div>
      <button
        type="button"
        id="create-product-group-btn"
        class="btn btn-sm btn-primary"
        routerLink="/client/{{ client?.id }}/product-group/new"
        >
        <span class="button-text">Create New</span>
        <span class="icon icon-right">
          <i class="fa fa-plus-circle" aria-hidden="true"></i>
        </span>
      </button>
    </div>
    <div
      class="intro-line-2"
      i18n="Introductory for creating a new product group - line 2"
      >
    This will be easier than lifting a space ship out of a swamp.
  </div>
  </div>
}

<hr />

<div class="button-container clearfix">
  <button
    id="prev-btn"
    class="btn btn-primary btn-with-icon"
    (click)="navigateToPrevious()"
    >
    <span class="icon icon-left">
      <i class="fa fa-arrow-left"></i>
    </span>
    <span class="btn-label">Previous</span>
  </button>
</div>

<message-dialog></message-dialog>
